module.exports = __webpack_public_path__ + "img/linkedin-logo.6a3b3c6f.svg";